import React,  { Component } from 'react';
import { BeatLoader } from 'react-spinners';
import Modal from 'react-modal';
import Select from 'react-select';
import NotificationSystem from 'react-notification-system';
import {_addNotification, _addNotificationError, getSchoolGrades} from "../../../server/util";
import { post, postWithHeaders} from "../../../server/actionsParent";
import { withRouter } from "react-router-dom";
import RichText from '../../Misc/RichText';
import { EditorState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import { get, postWithHeadersResponse } from '../../../server/actions';
import {required,email,zipValidation,isNumeric,phoneNo} from '../../../server/validationMethods'

const normalizeSmartPunctuation = (text = '') => {
    if (typeof text !== 'string') return text;
    const replacements = {
        '\u2018': '&#8216;',
        '\u2019': '&#8217;',
        '\u201C': '&#8220;',
        '\u201D': '&#8221;',
        '\u2013': '&#8211;',
        '\u2014': '&#8212;'
    };
    return text.replace(/[\u2018\u2019\u201C\u201D\u2013\u2014]/g, (match) => replacements[match] || match);
};

let schoolGrades = [];
class BroadcastMessage extends Component {

  constructor(props) {
    super(props);
    this.state = {
        loading: false,
        finalGradesArray:[],
        showTestModalWindow:false,
        testEmailId:'',
        students:[],
        isValidEmail:true,
        error: null,
        reqObj:{
                  schoolName:"",
                  subject:"",
                  message: EditorState.createEmpty(),
                  htmlText:'',
                  footer:"",
                  attachments:[],
                  selectedStudents:[]
                 },
        loggedUser: JSON.parse(sessionStorage.getItem('loggedInUserInfo'))
    }
    this.allGrades = this.allGrades.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

}

componentDidMount = ()=>{
    this._notificationSystem = this.refs.notificationSystem;
    this.getStudentsList();
    this.gradeCheck();
}

gradeCheck=()=>{
    let finalArray = [];
    finalArray= schoolGrades.map(item=>{
        let obj={name:item.label, value:item.value,checked:false,enabled:true};
        return obj;
    });
    this.setState({finalGradesArray:finalArray,loading:false, reqObj:{...this.state.reqObj, selectedStudents:[]}});
}

getStudentsList=()=>{
    const url=`/studentUsers/search/findByIsActiveAndMealSchoolSchoolIdAndSchoolYear?isActive=true&schoolId=${this.state.loggedUser.schoolId}&schoolYear=${this.state.loggedUser.schoolYear}&access_token=`;
    this.setState({loading:true})
    get(url).then((response) => {
        if (!response.ok) {
            throw Error(response.statusText);
        }
        return response.json();
    }).then(data => {
        this.setState({
            students: data._embedded.studentUsers||[],
            loading:false,
        });

    }).catch(
        (error) => {
            this.setState({
                loading: false
            })
            console.log('Get Meal Menu response', error)
        }
    )
}

onChangeGradeSelection=(value,selected)=>{
    console.log("Value::::",value)
    let checkboxArray=this.state.finalGradesArray;
    let itm,index;
    checkboxArray.forEach((item,i)=>{
        console.log("Item::::",item);
        if(value=='select_all'){
            if(item.enabled==true){
                console.log("SelectAllItem::::",selected);
                item.checked=selected;
                itm=item;
                index=i
                return true;
            }  
        }
        else{
        if(item.value==value){
            console.log("Lable:::::",item.label);
            item.checked=selected;
            itm=item;
            index=i
            return true;
        }
    }
    });

    checkboxArray[index]=itm;
    this.setState({finalGradesArray:checkboxArray, reqObj:{...this.state.reqObj, selectedStudents:[]}});
}

checkAllGrades = (event) => {        
    this.onChangeGradeSelection(event.target.value,event.target.checked);

    var checkboxes = document.getElementsByName("grades");
    let j = 0;
    for (let i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].checked) {
            j++
        }
    }
    var select_all = document.getElementById("select_all");
    if (j === checkboxes.length) {
        select_all.checked = true;
    } else {
        select_all.checked = false;
    }
}

allGrades() {
    var select_all = document.getElementById("select_all");
    this.onChangeGradeSelection('select_all',select_all.checked);
    //$('input[name="grades"]').prop('checked',this.checked);
    var checkboxes = document.getElementsByName("grades");
    for (let i = 0; i < checkboxes.length; i++) {
        if(!checkboxes[i].disabled)
        checkboxes[i].checked = select_all.checked;
    }
}

filterStudents=()=>{
    let selectGrade = [];
    let filterStudentsList=[];
    if (document.getElementById("select_all") && document.getElementById("select_all").checked == true){
         this.state.students.map(stud=>{
            filterStudentsList.push({ value: stud.studentId, label: `${stud.firstName} ${stud.lastName}`, grade:stud.gradeName });
        })
    }else {
        this.state.finalGradesArray.map(grade => {
             if (grade.checked){                
                selectGrade.push(grade.value);
             }
        });
        if(selectGrade.length==0){
            this.state.students.map(stud=>{
                filterStudentsList.push({ value: stud.studentId, label: `${stud.firstName} ${stud.lastName}`,grade:stud.gradeName });
            })
        }else{
            const list= this.state.students.filter(stud=>{
                return selectGrade.includes(stud.gradeName);
    
            });
            list.map(stud=>{
                filterStudentsList.push({ value: stud.studentId, label: `${stud.firstName} ${stud.lastName}`,grade:stud.gradeName });
            });
        }
        
    }
    return filterStudentsList;
}

handleSubmit(e, type='') {
    e.preventDefault();
    // let headers = {
    //      "Content-Type": "multipart/form-data",
    //     "Accept": "application/json"
    // }; 
    let user= this.state.loggedUser

    let selectGrade = [];

    if (document.getElementById("select_all").checked == true){
        selectGrade.push('all');
    }else {
        this.state.finalGradesArray.map(grade => {
             if (grade.checked){
                selectGrade.push(grade.value);
             }
        });
    }
    const {reqObj}=this.state;
    const normalizedHtmlText = normalizeSmartPunctuation(this.state.reqObj.htmlText || '');
    const normalizedSubject = normalizeSmartPunctuation(this.state.reqObj.subject || '');
    const normalizedFooter = normalizeSmartPunctuation(this.state.reqObj.footer || '');
   
    let data = {
            "grades": selectGrade,
            "schoolName": user.schoolName,
            "subject": normalizedSubject,
            "message": normalizedHtmlText,
            "footer": normalizedFooter,
            "email":this.state.testEmailId,
            "studentIds":reqObj.selectedStudents.map(stu=>stu.value)
        }
        
        if(normalizedSubject.trim()===''){
            _addNotificationError('subject is required.', this);
            return false;
        }
        if(normalizedHtmlText.replace(/<\/?[^>]+(>|$)/g, '').trim() == '' || normalizedHtmlText.length===0){
            _addNotificationError('message is required.', this);
            
            return false;
        } 
       /*  if((this.state.reqObj.footer||'').trim()==='') {
            _addNotificationError('footer is required.', this);
            return false;
        } */
        if(type!=='TEST'){
        if((selectGrade||[]).length===0 && this.state.reqObj.selectedStudents.length===0) {
            _addNotificationError('please select atleast one student or grade.', this);
            return false;
        }

        if(data.grades.length==0){
            if(reqObj.selectedStudents.length>0){
                const gradeList= reqObj.selectedStudents.map(stu=>stu.grade);
               data.grades= gradeList.filter((value, index, array) => array.indexOf(value) === index);
            }
        }
    }
    let headers = {
        "Content-Type": "multipart/form-data",
   };
    let formData=new FormData();
    formData.append('body',JSON.stringify(data));
    (this.state.reqObj.attachments||[]).map(file=>{
        formData.append('files',file);
    });
    
    postWithHeaders(`/custom/notification/${this.state.loggedUser.schoolId}/${this.state.loggedUser.schoolYear}?access_token=`,formData,undefined).then((response) => {
        console.log("Response::::",response);
        if (!response.ok) {
            throw Error(response.statusText);
        }
        return response.text();
    }).then(data => {
        if(type=='TEST'){
            this.setState({ loading: false, showTestModalWindow:false, testEmailId:''});
            _addNotification('Email sent successfully.', this)
        }else{
            const _reqObj={};
            _reqObj.subject='';
            _reqObj.message=EditorState.createEmpty();
            _reqObj.htmlText='';
            _reqObj.attachments=[];
            _reqObj.selectedStudents=[];
            _reqObj.footer='';
            this.setState({ loading: false, reqObj:{..._reqObj}});
            this.gradeCheck();
            document.getElementById("select_all").checked = false;
            _addNotification('Email sent Successfully.', this);
        }
        
         }).catch(
               (error) => {
                this.setState({ loading: false });
                _addNotificationError('Please try again!', this);
             }
       )
        return false;
}

cancelRequestForm=()=>{
    const _reqObj={};
    _reqObj.subject='';
    _reqObj.message=EditorState.createEmpty();
    _reqObj.htmlText='';
    _reqObj.footer='';
    this.setState({loading: false, reqObj:{..._reqObj}});
    this.gradeCheck();
    document.getElementById("select_all").checked = false;
    this.props.history.push('/schoolAdmin')
}

sendTestMail=(e)=>{
    if((this.state.testEmailId||'').trim()==''){
        _addNotificationError('Please enter your Email Id.', this);
    }else{this.handleSubmit(e,'TEST');           
    }
}
isValidEmail = (email) => {
    return /\S+@\S+\.\S+/.test(email);
  }

handleChange = (event) => {
    if (!this.isValidEmail(event.target.value)) {
      this.setState({error: 'Email is invalid'});
    } else {
      this.setState({error: null});
    }

    this.setState({testEmailId: event.target.value});
  };

renderTestMailModal=()=>{
    const alertStyle={
        content:{
            top: '40%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            width: '40%',
            transform: 'translate(-50%, -50%)',
            overflow: 'initial',
            WebkitBoxShadow: '0 5px 11px 0 rgba(0,0,0,0.18), 0 4px 15px 0 rgba(0,0,0,0.15)',
            boxShadow: '0 5px 11px 0 rgba(0,0,0,0.18), 0 4px 15px 0 rgba(0,0,0,0.15)'
        }
    }
    return <Modal isOpen={this.state.showTestModalWindow} style={alertStyle} >
    <div className="modal-header row">
        <h4 className="modal-title modal-title-color col-md-6" id="refundLabel">Test Email</h4>
        <div className="col-md-6"><button type="button" className="pull-right btn-danger" 
        onClick={() => {this.setState({showTestModalWindow:false})}}>X</button></div>
        </div>
        <div className="modal-body">
            <div className='row'>
                <div className='col-md-12'>
                    <div className="form-group">
                        <label>Enter email id for test mail:</label>
                       <input type="email" onChange={(e) => this.handleChange(e)} />
                            {this.state.error && <div style={{color: 'red'}}>{this.state.error}</div>}
                    </div>                    
                </div>
            </div>           
        </div>
        <div className="text-right">
            <button type="button" className="btn btn-danger btn-xs"
                onClick={()=>{
                    this.setState({showTestModalWindow:false, testEmailId:''});
                }}><i className="fa fa-check-circle" style={{ margin: '0 0 0 5px' }} ></i> Cancel
            </button>&nbsp;
            <button type="button" className="btn btn-success btn-xs" disabled={(this.state.error)?true:false}
                onClick={(e)=>{
                    this.sendTestMail(e);                    
                }}><i className="fa fa-check-circle" style={{ margin: '0 0 0 5px' }} ></i> Ok
            </button>
        </div>

    </Modal>
}

render() {
      schoolGrades = getSchoolGrades(0,false);
      const {reqObj, students}=this.state
      return (
        <section className="mainContent full-width clearfix">
                <NotificationSystem ref="notificationSystem"/>
                <div className='sweet-loading' style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000'}}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
        <div> 
            <div className="container" style={{marginTop:'25px'}}>
            <div className="col-md-offset-2 col-md-8 col-sm-12">
                    <div className="panel panel-primary" >
                        <div class="panel-heading text-center">
                            <h3 class="panel-title">Broadcast Message</h3>
                        </div>
                        <div className='panel-body'>
                    
                            <div className="form-group" >
                                <label>Subject: </label>
                                <input type='text' className="form-control" value={this.state.reqObj.subject}
                                    placeholder="subject" spellcheck="false" onChange={(e) => { 
                                    this.state.reqObj.subject=e.target.value;
                                    this.setState({reqObj:{...this.state.reqObj}});
                                        }}
                                 />
                            </div>
                            <div className="form-group">
                                <label>Message: </label>
                                <RichText editorState={this.state.reqObj.message} onEditorStateChange={(editorState)=>{
                                    this.state.reqObj.message=editorState;
                                    this.state.reqObj.htmlText=normalizeSmartPunctuation(draftToHtml(convertToRaw(this.state.reqObj.message.getCurrentContent())));
                                    this.setState({reqObj:{...this.state.reqObj}});
                                }} />
                                
                            </div>                            
                            
                            <div className='form-group'>
                                <label>Attachments :</label> <br />
                                {
                                        (reqObj.attachments||[]).map((file,i)=>{
                                            return <span className="label label-primary">{file.name} <span style={{cursor:'pointer'}} onClick={(e)=>{
                                                const {reqObj}=this.state;
                                                reqObj.attachments.splice(i,1);
                                                this.setState({reqObj:{...reqObj}});
                                            }}><i className='fa fa-trash'></i></span></span>
                                        })
                                }
                            </div>                 
                            <div className='form-group'>
                                <input type='file' multiple className='form-control' onChange={(e)=>{
                                    if(e.target.files.length>0){
                                        const {reqObj}=this.state;
                                        let files=e.target.files;
                                        reqObj.attachments=[...reqObj.attachments, ...files];
                                          this.setState({reqObj:{...reqObj}});                                   
                                    }
                                    e.target.value = null;
                                }} />
                            </div>
                            <div className="form-group" style={{float:'right'}} >
                                <a href='javascript:void(0)' onClick={(e) => {
                                            this.setState({showTestModalWindow:true, testEmailId:''});
                                    }}><i className="fa fa-share-square-o"></i><span>Send Test Mail</span></a>
                                
                            </div>
                            <br />
                            <div className="form-group">
                                <label className="custom-label col-md-3 text-left">Select Grades:</label>
                                <div className="col-md-7 input-group">
                                    <div class="styled-input-container styled-input--square">
                                        <div className="styled-input-single col-sm-12">
                                            <input type="checkbox" name="fieldset-6" id="select_all" onChange={this.allGrades} /> <label htmlFor="select_all">All</label>
                                        </div>
                                        {
                                            this.state.finalGradesArray.map(grade => {
                                                return (
                                                                    <div className="styled-input-single col-md-2 pull-left"
                                                                        style={{margin: '-15px 8px'}}>
                                                                        <input type="checkbox" name="grades"
                                                                            onChange={this.checkAllGrades}
                                                                            id={grade.name} value={grade.value} 
                                                                            checked={grade.checked?true:false}
                                                                            // disabled={grade.enabled?false:true}
                                                                            />
                                                                        <label htmlFor={grade.name}>{grade.name}</label>
                                                                    </div>
                                                                );
                                                            }
                                                        )}
                                                    </div>
                                                </div>
                                            </div> 
                            <div className="form-group">
                                <label>Select Students: </label>
                                <Select closeMenuOnSelect={false} isClearable={false} menuPlacement="auto" menuPortalTarget={document.body} onChange={(items)=>{
                                        const {reqObj}=this.state;
                                        reqObj.selectedStudents=[...items||[]];
                                        this.setState({reqObj:{...reqObj}});
                                    }}
                                    value={reqObj.selectedStudents||[]}
                                    isMulti options={this.filterStudents()}
                                    />

                            </div>
                            <div className="col-md-7 col-md-offset-3 text-center">                                
                                    <button className="btn btn-danger btn-sm" onClick={() => { this.cancelRequestForm()
                                }}
                                                type="submit">Cancel
                                            </button>&nbsp;&nbsp;
                                                        <button type="submit" id="submit" onClick={(e) => { 
                                            {
                                                    this.handleSubmit(e);                                
                                            }
                                            }} className="btn btn-sm btn-success"><i
                                                            className="fa fa-share-square-o"></i><span>Send</span></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {
            this.renderTestMailModal()
        }
    </section> 
      );
    }
  }
export default withRouter(BroadcastMessage);


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/broadcastMessage/index.jsx